import { NavLink } from "react-router-dom";
import { cn } from "../../lib/utils";
import { useLocalization } from "../../lib/i18n";

export function AppFooter() {
  const { t } = useLocalization();
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    cn(
      "text-[13px] font-semibold tracking-[0.01em] transition-colors",
      isActive ? "text-brand" : "text-foreground-muted hover:text-foreground"
    );

  return (
    <footer className="mx-auto w-full max-w-[64rem] border-t border-border-subtle px-4 pt-4 pb-6 md:px-0">
      <nav className="flex items-center justify-center gap-4" aria-label="Footer links">
        <NavLink to="/privacy" className={linkClass}>
          {t("settings.privacyPolicy")}
        </NavLink>
        <span className="text-[13px] text-foreground-subtle">|</span>
        <NavLink to="/terms" className={linkClass}>
          {t("common.terms")}
        </NavLink>
        <span className="text-[13px] text-foreground-subtle">|</span>
        <NavLink to="/support" className={linkClass}>
          {t("settings.support")}
        </NavLink>
      </nav>
      <div className="mt-3 flex flex-col items-center gap-1 text-center text-[12px] leading-5 text-foreground-muted">
        <p>SportEx100 is operated by SportEx100 Technologies Inc.</p>
        <p>
          Support:{" "}
          <a className="font-semibold text-brand hover:text-brand-hover" href="mailto:info@sportex100.com">
            info@sportex100.com
          </a>
        </p>
      </div>
    </footer>
  );
}
